import { types } from 'mobx-state-tree';
import Actions from './Actions';
const Analytics = types
    .model({
    firstProspectingScoutSearchDate: types.maybeNull(types.Date),
    firstProspectingFullShowDate: types.maybeNull(types.Date),
    registerDate: types.maybeNull(types.Date),
    lastTermsAndConditionsApprovalDate: types.maybeNull(types.Date),
    firstShowDate: types.maybeNull(types.Date),
    firstSearchDate: types.maybeNull(types.Date),
})
    .actions(Actions);
export default Analytics;
